/**
 * Postavke čitanja računa iz datoteke — vrijede za cijelu aplikaciju. Uz trenutne vrijednosti
 * dolaze i ugrađeni defaulti, da ekran zna što vrijedi kad je polje prazno.
 */
export interface InvoiceExtractionSettings {
  /** "direct" — model gleda stranicu; "ocr" — Document AI čita tekst pa ga model tumači. */
  pipeline: string;
  model: string;
  ocrModel: string;
  prompt: string;
  defaultModel: string;
  defaultOcrModel: string;
  defaultPrompt: string;
  /** Je li Document AI podešen — bez njega OCR put nije dostupan. */
  isOcrAvailable: boolean;
  /** Je li postavljen API ključ — bez njega čitanje ne radi bez obzira na postavke. */
  isConfigured: boolean;
  googleProjectId: string;
  googleProcessorId: string;
  googleLocation: string;
  /** Je li ključ servisnog računa spremljen; sam ključ se nikad ne vraća s poslužitelja. */
  hasGoogleCredentials: boolean;
  /** Servisni račun iz spremljenog ključa, da se vidi koji je podešen. */
  googleServiceAccount: string;
  /** Je li podešen ključ za šifriranje; bez njega se ključ servisnog računa ne može spremiti. */
  canStoreCredentials: boolean;
}

export interface InvoiceExtractionSettingsFormValues {
  pipeline: string;
  model: string;
  ocrModel: string;
  prompt: string;
  googleProjectId: string;
  googleProcessorId: string;
  googleLocation: string;
  /** Novi ključ servisnog računa; prazno znači da spremljeni ostaje nepromijenjen. */
  googleCredentialsJson: string;
}

/** Načini čitanja računa; moraju odgovarati backendu. */
export const InvoiceExtractionPipeline = {
  DIRECT: "direct",
  OCR: "ocr",
} as const;

/** Oznaka koju upute moraju sadržavati — na njeno mjesto ide popis vrsta troška. */
export const EXPENSE_TYPES_PLACEHOLDER = "{codes}";

/** Zadana regija Document AI procesora. */
export const DEFAULT_GOOGLE_LOCATION = "eu";
